import styled, { css } from 'styled-components';
import { ReactSVG } from 'react-svg';

export const ToUploadList = styled.ul`
  margin: 16px 0;
  padding: 0;
  list-style: none;
`;

export const File = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  word-break: break-word;
  :last-child {
    margin-bottom: 0;
  }
`;

export const RemoveIcon = styled(ReactSVG)`
  margin-right: 10px;
  min-width: 16px;
  width: 16px;
  cursor: pointer;
  fill: ${({ theme }) => `${theme.colors.primaries.default}`};
`;

export const DownloadIcon = styled(RemoveIcon)`
  fill: #222222;
`;